import axios from 'axios';


export default {
    getQuotationList:()=>{
        return axios.get('cotizaciones');
    },
    getPlantillaQuotationList:()=>{
        return axios.get('plantilla/listado/cotizaciones');
    },
    exportQuotation:(period) => {
        return axios.post('exportar/cotizaciones', period);
    }   
}